module.exports = __webpack_public_path__ + "static/img/TCL超级筒T7H.c2d54135.png";